import { Box, Button, useMediaQuery, useTheme, MenuItem, InputLabel, FormControl } from "@mui/material";
import Select from '@mui/material/Select';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";
import DeleteIcon from '@mui/icons-material/Delete';
import { tokens } from "../../../../theme";
import AddIcon from '@mui/icons-material/Add';
import * as yup from "yup";
import { Formik } from "formik"
import { useUserCompany } from "../../../hooks/user/useUserCompany.tsx";

const UserCompanies = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode)
    const isNonMobile = useMediaQuery("(min-width:600px)")

    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const _id = query.get('id')

    const {
        loadingRequest,
        errorRequest,
        userCompanyListData,
        userCompanyListLoading,
        userCompanyListError,
        companyListLoading,
        companyListError,
        filteredCompanyList,
        initialValues,
        accessAllCompany,

        deleteUserCompany,
        handleChangeAction,
        handleFormSubmit
    } = useUserCompany();

    const userSchema = yup.object().shape({
        companies: yup.string().required("* Valor Requerido"),
    })

    const columns = [
        {
            field: "idUser",
            headerName: "ID",
            cellClassName: "id-column--cell",
            headerClassName: "id-header--cell",
            hideable: false
        },
        {
            field: "name",
            headerName: "Nombre",
            flex: 0.5,
            cellClassName: "name-column--cell",
            minWidth: 120
        },
        {
            minWidth: 200,
            filterable: false,
            sortable: false,
            field: "actions",
            headerName: "Acciones",
            headerAlign: "center",
            cellClassName: "actions-column--cell",
            renderCell: ({ row: { id } }) => {
                if(accessAllCompany || (Array.isArray(userCompanyListData) && userCompanyListData.length > 1)) {
                    return (
                        <Box
                            width="80%"
                            maxWidth="175px"
                            height="75%"
                            maxHeight="35px"
                            display="flex"
                            justifyContent="center"
                            m="0 auto">
                            <Button
                                color="error"
                                variant="contained"
                                onClick={() => { deleteUserCompany(id, _id) }}>
                                <DeleteIcon />
                                <Box sx={{ ml: "5px" }}>
                                    Eliminar Empresa
                                </Box>
                            </Button>
                        </Box>
                    )
                }
                
            }
        }
    ]

    if (userCompanyListLoading || loadingRequest || companyListLoading)
        return (<Loading />)

    if (userCompanyListError || errorRequest || companyListError)
        return (<FatalError />)

    return (
        <Box p={1} >
            {<Header title="" subtitle="Listado de Empresas Asignados" />}
            <Formik
                enableReinitialize={true}
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={userSchema}
            >
                {({
                    values,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue
                }) => (
                    <form onSubmit={handleSubmit} >
                        <Box
                            display="grid"
                            gap="15px"
                            marginBottom="15px"
                            gridTemplateColumns="repeat(12, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 12" }
                            }}
                        >
                            {<FormControl variant="filled"
                                sx={{ gridColumn: "span 12" }}
                                required>
                                <InputLabel id="select-companies-label" name="select-companies-label">Seleccionar empresa</InputLabel>
                                <Select
                                    labelId="select-companies-label"
                                    id="select-companies"
                                    fullWidth={!isNonMobile}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        handleChangeAction(values, e.target);
                                        setFieldValue("companies", e.target.value);
                                    }}
                                    value={values.companies || ''}
                                    name="companies"
                                    size="small"
                                >
                                    {filteredCompanyList.map((company) => (
                                        <MenuItem key={company.id} value={company.id.toString()}>
                                            {company.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                        </Box>
                        <Box display="flex" justifyContent="end" mt="20px">
                            <Button type="submit" color="secondary" variant="contained">
                                <AddIcon />
                                Agregar Empresa
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>
            <Box m="5px 0px 50px 0" sx={{
                "& .MuiDataGrid-root": {
                    border: "none",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none"
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[700],
                    borderBottom: "none",
                    color: "white"
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[700],
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                },
                "& .MuiToolbar-gutters": {
                    color: "white"
                }

            }}>
                <DataGrid
                    autoHeight
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                idUser: false,
                                actions: true
                            },
                        },
                    }}
                    localeText={{ noRowsLabel: "Este usuario tiene acceso a TODAS las empresas" }}
                    rows={userCompanyListData}
                    columns={columns}
                    getRowId={(row) => row.id}
                    density="compact"
                    slots={{
                        toolbar: GridToolbar,
                    }}
                />
            </Box>
        </Box>
    );
}

export default UserCompanies;